export function getLineStatusTagColor(status: string): string {
    const s = status.toLowerCase().trim();
    if (s === 'open' || s === 'ordered') return 'green';
    if (s === 'ap entered') return 'blue';
    if (s === 'received no ap') return 'gray';
    if (s === 'received' || s === 'complete' || s === 'completed') return 'blue';
    if (s === 'partial' || s === 'partially received') return 'yellow';
    if (s === 'cancelled' || s === 'canceled' || s === 'voided') return 'red';
    if (s === 'closed') return 'gray';
    if (s === 'backordered' || s === 'back ordered') return 'orange';
    return 'gray';
}

const LINE_STATUS_DISPLAY_MAP: Record<string, string> = {
    'received no ap': 'Received',
};

export function getLineStatusDisplayText(status: string): string {
    return LINE_STATUS_DISPLAY_MAP[status.toLowerCase().trim()] ?? status;
}
